import { render, staticRenderFns } from "./EditPlanoModal.vue?vue&type=template&id=34048648&scoped=true"
import script from "./EditPlanoModal.vue?vue&type=script&lang=js"
export * from "./EditPlanoModal.vue?vue&type=script&lang=js"
import style0 from "./EditPlanoModal.vue?vue&type=style&index=0&id=34048648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34048648",
  null
  
)

export default component.exports